import React from 'react';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { Avatar, AvatarSize } from 'wix-ui-tpa';
import classNames from 'classnames';
import { LIST_ITEM, DELETED, REPLY, TOP_LEVEL, PENDING, COMMENT_CONTENT, } from '../../../common/constants/data-hooks';
import ListItemContainer from '../list-item-container/list-item-container';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../api-provider';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { st, classes } from './comment-deleted.st.css';
export const CommentDeleted = ({ isReply = false, isPending = false, id, }) => {
    const isMobile = useApi(getIsMobile);
    const { hideAvatars } = useConfiguration();
    const t = useTranslate();
    return (React.createElement(ListItemContainer, { id: id, dataHook: classNames(LIST_ITEM, DELETED, isReply ? REPLY : TOP_LEVEL, isPending && PENDING), isPending: isPending, isReply: isReply },
        React.createElement("div", { "data-hook": DELETED, className: st(classes.root, { isReply, isMobile }) },
            !hideAvatars && (React.createElement(Avatar, { className: classes.avatar, size: isReply ? AvatarSize.small : AvatarSize.medium })),
            React.createElement("span", { className: classes.message, "data-hook": COMMENT_CONTENT }, t(isReply ? 'reply.was-deleted' : 'comment.was-deleted')))));
};
//# sourceMappingURL=comment-deleted.js.map